module.exports = __webpack_public_path__ + "img/左右翻转.bbca6567.svg";